import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { useTheme } from "../../contexts/ThemeContext";

export const LoginPage = () => {
  const { instance } = useMsal();
  const { theme, isDark } = useTheme();
  const [loading, setLoading] = useState(false);
  const handleLogin = async () => {
    setLoading(true);
    try { await instance.loginPopup(loginRequest); }
    catch(e) { console.error(e); setLoading(false); }
  };
  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:`linear-gradient(135deg,${theme.bg.primary} 0%,${theme.bg.tertiary} 50%,${theme.bg.primary} 100%)`,padding:24}}>
      <div style={{background:theme.bg.secondary,border:"1px solid "+theme.border,borderRadius:16,padding:"48px 56px",textAlign:"center",maxWidth:480,width:"100%",position:"relative",boxShadow:"0 24px 64px rgba(0,0,0,.6)"}}>
        <div style={{position:"absolute",top:0,left:"10%",right:"10%",height:2,background:`linear-gradient(90deg,transparent,${theme.accent},transparent)`,borderRadius:"0 0 4px 4px"}}/>
        <div style={{width:72,height:72,borderRadius:"50%",background:`linear-gradient(135deg,${theme.accent}22,${theme.accent}44)`,border:"2px solid "+theme.accent+"44",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 24px",fontSize:32}}>
          {String.fromCodePoint(0x2696)}
        </div>
        <h1 style={{fontFamily:"Cormorant Garamond,Georgia,serif",fontSize:36,fontWeight:600,color:theme.text.primary,margin:"0 0 6px",letterSpacing:"-0.02em"}}>LexCore</h1>
        <p style={{color:theme.accent,fontSize:15,fontWeight:500,letterSpacing:"0.15em",textTransform:"uppercase",margin:"0 0 12px"}}>Contract Management System</p>
        <hr style={{border:"none",borderTop:"1px solid "+theme.border,margin:"24px 0"}}/>
        <p style={{color:theme.text.secondary,fontSize:15,lineHeight:1.6,margin:"0 0 32px"}}>
          Sign in with your Microsoft 365 account to access the contract management portal. Only authorized users may access this system.
        </p>
        <button onClick={handleLogin} disabled={loading} style={{width:"100%",padding:"14px 24px",background:loading?theme.accent+"99":theme.accent,color:isDark?theme.bg.primary:theme.text.primary,border:"none",borderRadius:8,fontFamily:"'Helvetica Neue',Helvetica,Arial,sans-serif",fontSize:15,fontWeight:600,cursor:loading?"not-allowed":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:10,transition:"all 0.2s"}}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="0" y="0" width="9" height="9" fill="#F25022"/>
            <rect x="11" y="0" width="9" height="9" fill="#7FBA00"/>
            <rect x="0" y="11" width="9" height="9" fill="#00A4EF"/>
            <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
          </svg>
          {loading ? "Signing in..." : "Sign in with Microsoft 365"}
        </button>
        <p style={{color:theme.border,fontSize:15,margin:"20px 0 0"}}>Unauthorized access is prohibited and monitored.</p>
      </div>
    </div>
  );
};
